import React, { useEffect, useRef, useState } from 'react';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import NavigationBar from '../components/Navbar/navbar';
import '../styles/education-style.css';
import '../styles/responsive.css';
import { jwtDecode } from 'jwt-decode';
//images
import SearchIcon from '../images/home-landing-page/search-icon.png';
import DirectoryIcon from '../images/home-landing-page/directory-icon.png';
import JobIcon from '../images/home-landing-page/job-icon.png';
import ChatIcon from '../images/home-landing-page/chat-icon.png';
import SocialMediaIcon from '../images/home-landing-page/social-media-icons.png';
import Job1 from '../images/home-landing-page/job-1.png';
import Job2 from '../images/home-landing-page/job-2.png';
import Job3 from '../images/home-landing-page/job-3.png';
import Job4 from '../images/home-landing-page/job-4.png';
import CoworkerIcon from '../images/home-landing-page/co-workers.png';
import customerAvtar from '../images/home-landing-page/customer-avatar.png';
import EfficientIcon from '../images/home-landing-page/efficient-icon.png';
import Footer from '../components/Footer/footer';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
import BannerVector from '../images/home-landing-page/banner-round-vector.png';
import ConnectWithClientsImage from '../images/home-landing-page/buildings-vector.png';
import User1 from '../images/home-landing-page/user1.png';
import User2 from '../images/home-landing-page/user2.png';
import User3 from '../images/home-landing-page/user3.png';
import ReviewStar from '../images/home-landing-page/review-star.svg';
import Slider from "react-slick";


import picprivatecertifier from '../assets/images/edu/pc.png';
import pictownplanner from '../assets/images/edu/townplanner.png';
import picprojman from '../assets/images/edu/project-man-profile.png';
import picprocesses from '../assets/images/edu/processes.png';
import picbuilderprofile from '../assets/images/edu/builder-profile.png';
import piccarpenter from '../assets/images/edu/carpenter.png';
import picbuilders from '../assets/images/edu/builders.png';
import pichandy from '../assets/images/edu/pichandy.png';

import picProcess from '../assets/images/edu/process.png';
import picBuilding1 from '../assets/images/edu/building.png';
import picTradie from '../assets/images/edu/tradie.png';
import picSearch from '../assets/images/edu/search.png';


import EduTile from "./EduTile";
import "./EduTileGrid.css";


const EducationCentre = () =>
{
  const [searchTerm, setSearchTerm] = useState('');
  const [postCode, setPostCode] = useState('');
  const [results, setResults] = useState([]);
  const [username, setUsername] = useState('');
  const navigate = useNavigate();
  const MAX_RESULTS = 20;

  const tileData = [
    {
      icon: picProcess,
      title: "Understanding the Building Process",
      description: "Learn about time deadlines and costs while staying on schedule.",
      image: picProcess,
    },
    {
      icon: picTradie,
      title: "Chat to an AI Expert",
      description: "Chat to our AI experts who can answer your building related questions",
      image: picTradie,
    },
    {
      icon: picSearch,
      title: "Building Terminology",
      description: "Understand construction and renovation terminology.",
      image: picSearch,
    },
    {
      icon: picBuilding1,
      title: "Renovation Planning",
      description: "Plan and execute successful renovations.",
      image: picBuilding1,
    },
    {
        icon: picBuilding1,
        title: "Get Cost Estimations",
        description: "Estimate project costs and find top-rated tradies.",
        image: picBuilding1,
      },
  
];
  

  const handleLoginClick = () =>
  {
    navigate('/login');
  };

  const handleSignupClick = () =>
  {
    navigate('/register-home-user');
  };

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "275px",
    slidesToShow: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 2,
          centerPadding: "175px",
        },
      },
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 2,
          centerPadding: "75px",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  useEffect(() =>
  {
    const token = localStorage.getItem('token');
    if (token !== null)
    {
      const decodeToken = jwtDecode(token);
      setUsername(decodeToken.UserName);
    }
  }, [username]);

  const handleSearchChange = async (e) =>
  {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);

    if (searchValue.length > 0)
    {
      try
      {
        const response = await axios.get(`${API_BASE_URL}/api/Search/searchprofessions?search=${searchValue}`);
        setResults(response.data.slice(0, MAX_RESULTS)); // Limit to MAX_RESULTS
      } catch (error)
      {
        console.error('Error fetching professions:', error);
      }
    } else
    {
      setResults([]);
    }
  };




  // Set the selected profession in the search box and clear results
  const addItem = (item) =>
  {
    setSearchTerm(`${item.name}`); // Set the search term to selected item
    setResults([]); // Clear the dropdown
  };

  return (
    <div >
      {username ? (<DashboardNavbar prefix={''} />) : (<NavigationBar handleLoginClick={handleLoginClick} handleSignupClick={handleSignupClick} prefix={''} />)}

      {username ? (<div>
        <section class="search-banner">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">

                <div class="search-options">
                  <h3>WHAT ELSE DO YOU WANT TO DO?</h3>

                  <div className="edu-tile-grid-container">
                    <div className="edu-tile-grid">
                        {tileData.map((tile, index) => (
                        <EduTile
                            key={index}
                            icon={tile.icon}
                            title={tile.title}
                            description={tile.description}
                            image={tile.image}
                        />
                        ))}
                    </div>
                    </div>


                  <div class="options-mylist">
                    <a class="option-box" href='/directory'>
                      <figure class="icon-list">
                        <img src={DirectoryIcon} />
                      </figure>
                      <span>
                        Browse Directory
                      </span>
                    </a>
                    <a class="option-box" href='/JobsDashboard'>
                      <figure class="icon-list">
                        <img src={JobIcon} />
                      </figure>
                      <span>
                        View or Post Jobs
                      </span>
                    </a>
                    <a class="option-box" href='/messages'>
                      <figure class="icon-list">
                        <img src={ChatIcon} />
                      </figure>
                      <span>
                        Read Messages
                      </span>
                    </a>
                    <a class="option-box" href='/social-media'>
                      <figure class="icon-list">
                        <img src={SocialMediaIcon} />
                      </figure>
                      <span>
                        Connect on Social
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="featured-professionals">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <h2 class="inner-page-heading">
                  Featured Professionals
                </h2>
                <p class="inner-heading-desc">These local business have made an impact this week. Check out there
                  jobs</p>
                <div class="featured-professional-jobs">
                  <div class="job-box">
                    <figure class="job-image">
                      <img src={Job1} />
                    </figure>
                    <div class="job-data">
                      <p class="job-name">Madhuram Construction</p>
                      <p class="job-skills">505 Job Skills</p>
                      <button class="learn-button">Learn More</button>
                    </div>
                  </div>
                  <div class="job-box">
                    <figure class="job-image">
                      <img src={Job2} />
                    </figure>
                    <div class="job-data">
                      <p class="job-name">Maecenas Ultricies</p>
                      <p class="job-skills">505 Job Skills</p>
                      <button class="learn-button">Learn More</button>
                    </div>
                  </div>
                  <div class="job-box">
                    <figure class="job-image">
                      <img src={Job3} />
                    </figure>
                    <div class="job-data">
                      <p class="job-name">Aliquam Fermentum</p>
                      <p class="job-skills">505 Job Skills</p>
                      <button class="learn-button">Learn More</button>
                    </div>
                  </div>
                  <div class="job-box">
                    <figure class="job-image">
                      <img src={Job4} />
                    </figure>
                    <div class="job-data">
                      <p class="job-name">Consectetur Sollicitudin</p>
                      <p class="job-skills">505 Job Skills</p>
                      <button class="learn-button">Learn More</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="useful-tips bottom-hammer-vector">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 tips-main-wrapper">
                <div class="tips-image">
                  <figure>
                    <img src={CoworkerIcon} />
                  </figure>
                  <div class="customer-success-info  advantage-box">
                    <figure>
                      <img src={customerAvtar} />
                    </figure>
                    <p>99%
                      <span>Customer Success</span>
                    </p>
                  </div>

                  <div class="tool-efficiency advantage-box">
                    <figure>
                      <img src={EfficientIcon} />
                    </figure>
                    <p>95%
                      <span>
                        More Effecient
                      </span>
                    </p>
                  </div>


                </div>
                <div class="tips-data">
                  <h2 class="inner-page-heading text-left">
                    Useful Tips
                  </h2>
                  <p>
                    View our useful learning resources to get advice
                    on hiring and the building process
                  </p>
                  <button class="btn theme_btn" onClick={() => navigate('/business-home')}>
                    Post a Job
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>) : (



        <div class="search-job-page">
        {/* No username - not logged in */}

          <section class="connect-with-clients blue_bg_section" style={{paddingTop: 20}}>
            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <h2>Build Start Learning Centre</h2>
                </div>
              </div>
            </div>
          </section>


          <section class="search-banner">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">

                <div class="search-options">
                  <h3>WHAT DO YOU WANT TO DO?</h3>

                  <div className="edu-tile-grid-container">
                    <div className="edu-tile-grid">
                        {tileData.map((tile, index) => (
                        <EduTile
                            key={index}
                            icon={tile.icon}
                            title={tile.title}
                            description={tile.description}
                            image={tile.image}
                        />
                        ))}
                    </div>
                    </div>


                  <div class="options-list">
                    <a class="option-box" href='/ai-consultants'>
                      <figure class="icon-list">
                        <img src={picprivatecertifier} />
                      </figure>
                      <span>
                        Consult with an AI Expert
                      </span>
                    </a>
                    <a class="option-box" href='/JobsDashboard'>
                      <figure class="icon-list">
                        <img src={picprocesses} />
                      </figure>
                      <span>
                        Learn about the Building and Approval Process
                      </span>
                    </a>
                    <a class="option-box" href='/messages'>
                      <figure class="icon-list">
                        <img src={picbuilders} />
                      </figure>
                      <span>
                        Understand Building Speak and Terminology
                      </span>
                    </a>
                    <a class="option-box" href='/social-media'>
                      <figure class="icon-list">
                        <img src={pichandy} />
                      </figure>
                      <span>
                        Do's and Don'ts with Building and Renos
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>



          <section class="connect-with-clients blue_bg_section">
            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <h2>Build Start Learning Centre</h2>
                  <p>Ask an AI Expert or get great tips on the building process!</p>
                  <div class="connect_btns">
                    <button class="btn theme_btn themeWhite_btn" onClick={() => navigate('/business-home')}>List Your Business Today</button>
                    <button class="btn theme_btn">Learn More</button>
                  </div>

                  <div class="connect_with_clients_image">
                    <img src={ConnectWithClientsImage} />
                  </div>

                </div>
              </div>
            </div>
          </section>

          <section class="post-job-section">
            <div class="container">
              <div class="row">
                <div class="col-sm-12">

                  <div class="post-job-wrapper">
                    <div class="post-job-box">

                      <div class="post-job-heading">
                        <h3>
                          Post a Job and get
                          it done. No Fuss
                        </h3>
                        <p>Post a job and wait for highly rated tradies
                          contact you</p>

                      </div>
                      <a href='/business-home' class="btn btn-primary">
                        Post a Job
                      </a>



                    </div>
                    <div class="post-job-box post-job-blue">
                      <div class="post-job-heading">
                        <h3>Connect Instantly
                          with Tradies via our
                          Social Network</h3>
                        <p>Post a job and wait for highly
                          rated tradies contact you</p>
                      </div>

                      <a href='/' class="btn btn-primary">
                        Connect Via Social
                      </a>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
          <section class="user-testimonial bottom-hammer-vector">
            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <h2>Hear What Thousands
                    of Our Users Think About Us</h2>
                  <p class="heading-desc">
                    Read about experiences of our users and see how we can
                    connect you with the TOP Professionals in town.
                  </p>






                </div></div></div>
            <div class="testimonial-slider">
              <Slider {...settings}>
                <div class="testimonial-box-data-main">
                  <div class="testimonial-box-data">
                    <figure class="testimonial-user">
                      <img src={User1} />
                    </figure>

                    <div class="testimonial-stars">
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                    </div>

                    <div class="testimonial-text">
                      <h5>
                        Only quality pros here
                      </h5>
                      <p>
                        “Aenean ut neque felis acondientum
                        finibus hedrrit lorem. Condimentum
                        efficitur elit sit ditum tortor tincidunt.
                        Maecenas ultrices quis tellus non
                        tempus aliquam faucibus.”
                      </p>
                    </div>

                    <div class="testimonial-author">
                      <h5>
                        John Doe
                      </h5>
                      <p>
                        CEO & Founder
                      </p>
                    </div>

                  </div>
                </div>
                <div class="testimonial-box-data-main">
                  <div class="testimonial-box-data">
                    <figure class="testimonial-user">
                      <img src={User2} />
                    </figure>
                    <div class="testimonial-stars">
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                    </div>

                    <div class="testimonial-text">
                      <h5>
                        Only quality pros here
                      </h5>
                      <p>
                        “Aenean ut neque felis acondientum
                        finibus hedrrit lorem. Condimentum
                        efficitur elit sit ditum tortor tincidunt.
                        Maecenas ultrices quis tellus non
                        tempus aliquam faucibus.”
                      </p>
                    </div>

                    <div class="testimonial-author">
                      <h5>
                        John Doe
                      </h5>
                      <p>
                        CEO & Founder
                      </p>
                    </div>
                  </div>
                </div>
                <div class="testimonial-box-data-main">
                  <div class="testimonial-box-data">
                    <figure class="testimonial-user">
                      <img src={User3} />
                    </figure>
                    <div class="testimonial-stars">
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                    </div>

                    <div class="testimonial-text">
                      <h5>
                        Only quality pros here
                      </h5>
                      <p>
                        “Aenean ut neque felis acondientum
                        finibus hedrrit lorem. Condimentum
                        efficitur elit sit ditum tortor tincidunt.
                        Maecenas ultrices quis tellus non
                        tempus aliquam faucibus.”
                      </p>
                    </div>

                    <div class="testimonial-author">
                      <h5>
                        John Doe
                      </h5>
                      <p>
                        CEO & Founder
                      </p>
                    </div>
                  </div></div>
                <div class="testimonial-box-data-main">
                  <div class="testimonial-box-data">
                    <figure class="testimonial-user">
                      <img src={User1} />
                    </figure>
                    <div class="testimonial-stars">
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                    </div>

                    <div class="testimonial-text">
                      <h5>
                        Only quality pros here
                      </h5>
                      <p>
                        “Aenean ut neque felis acondientum
                        finibus hedrrit lorem. Condimentum
                        efficitur elit sit ditum tortor tincidunt.
                        Maecenas ultrices quis tellus non
                        tempus aliquam faucibus.”
                      </p>
                    </div>

                    <div class="testimonial-author">
                      <h5>
                        John Doe
                      </h5>
                      <p>
                        CEO & Founder
                      </p>
                    </div>
                  </div></div>
                <div class="testimonial-box-data-main">
                  <div class="testimonial-box-data">
                    <figure class="testimonial-user">
                      <img src={User2} />
                    </figure>
                    <div class="testimonial-stars">
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                    </div>

                    <div class="testimonial-text">
                      <h5>
                        Only quality pros here
                      </h5>
                      <p>
                        “Aenean ut neque felis acondientum
                        finibus hedrrit lorem. Condimentum
                        efficitur elit sit ditum tortor tincidunt.
                        Maecenas ultrices quis tellus non
                        tempus aliquam faucibus.”
                      </p>
                    </div>

                    <div class="testimonial-author">
                      <h5>
                        John Doe
                      </h5>
                      <p>
                        CEO & Founder
                      </p>
                    </div>
                  </div></div>
                <div class="testimonial-box-data-main">
                  <div class="testimonial-box-data">
                    <figure class="testimonial-user">
                      <img src={User3} />
                    </figure>
                    <div class="testimonial-stars">
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                      <img src={ReviewStar} />
                    </div>

                    <div class="testimonial-text">
                      <h5>
                        Only quality pros here
                      </h5>
                      <p>
                        “Aenean ut neque felis acondientum
                        finibus hedrrit lorem. Condimentum
                        efficitur elit sit ditum tortor tincidunt.
                        Maecenas ultrices quis tellus non
                        tempus aliquam faucibus.”
                      </p>
                    </div>

                    <div class="testimonial-author">
                      <h5>
                        John Doe
                      </h5>
                      <p>
                        CEO & Founder
                      </p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </section>

        </div>

      )}
      <Footer />
    </div>
  );
}

export default EducationCentre;